/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Error limited model
 * @export
 * @interface ErrorLimited
 */
export interface ErrorLimited {
    /**
     * Error limited message
     * @type {string}
     * @memberof ErrorLimited
     */
    error: string;
}

/**
 * Check if a given object implements the ErrorLimited interface.
 */
export function instanceOfErrorLimited(value: object): value is ErrorLimited {
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ErrorLimitedFromJSON(json: any): ErrorLimited {
    return ErrorLimitedFromJSONTyped(json, false);
}

export function ErrorLimitedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorLimited {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'],
    };
}

export function ErrorLimitedToJSON(json: any): ErrorLimited {
    return ErrorLimitedToJSONTyped(json, false);
}

export function ErrorLimitedToJSONTyped(value?: ErrorLimited | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

